import React, {useEffect, useMemo, useRef, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Tooltip} from 'primereact/tooltip';
import ReportsServices from "../../../services/ReportsServices";
import Spinner from "reactjs-simple-spinner";


const InothoPoliciesDueToMatureReport = (props) => {


    const InothoPoliciesColumns = useMemo(
        () => [
            {
                header: 'Policy',
                field: 'policy_number',
            },
            {
                header: 'Aggregator',
                field: 'name',
            },
            {
                header: 'Policy Type',
                field: 'policy_type',
            },
            {
                header: 'Commencement Date',
                field: 'commencement_date'
            },
            {
                header: 'Premium',
                field: 'premium'
            },
            {
                header: 'Total Premium',
                field: 'total_premium'
            },
            {
                header: 'Sum Assured',
                field: 'sum_assured'
            },
            {
                header: 'Payment Frequency',
                field: 'payment_frequency',
            },
            {
                header: 'Payment',
                field: 'payment_method',
            },
            {
                header: 'Full Payment(Months)',
                field: 'months_with_full_payment'
            },
            {
                header: 'Next Invoicing Date',
                field: 'next_invoicing_date'
            },
            {
                header: 'Status',
                field: 'policy_status'
            },
            {
                header: 'Created At',
                field: 'created_at',
            },
            {
                header: 'Created By',
                field: 'created_by',
            },
            {
                header: 'Updated At',
                field: 'updated_at',
            },
            {
                header: 'Modified By',
                field: 'updated_by',
            },
        ],
        []
    )
    const [data, setData] = useState([])

    const [selectedData, setSelectedData] = useState([])
    const dt = useRef(null);

    const exportColumns = InothoPoliciesColumns.map(col => ({title: col.header, dataKey: col.field}));

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const exportPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, data);
                doc.save('inotho_policies_due_to_mature_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }


    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(data);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'inotho_policies_due_to_mature_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + EXCEL_EXTENSION);
            }
        });
    }

    const onSelectionChange = (e) => {
        setSelectedData(e.value);
    }

    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true)
        ReportsServices.inothoDueToMature()
            .then(res => {
                console.log("data: ", res);
                setData(res.data.data)
                setLoading(false)
            }).catch(err => {
            console.log('error: ', err)
            setData([])
            toast.error('Error loading data. Reload page, ' +
                'if error persist contact system administrator', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
        })

    }, []);

    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    // const footer = `In total there are ${data ? data.length : 0} commissions.`;

    /**
     *  Filter Modes
     */
        // PrimeReact.filterMatchModeOptions = {
        //     text: [
        //         FilterMatchMode.STARTS_WITH,
        //         FilterMatchMode.CONTAINS,
        //         FilterMatchMode.NOT_CONTAINS,
        //         FilterMatchMode.ENDS_WITH,
        //         FilterMatchMode.EQUALS,
        //         FilterMatchMode.NOT_EQUALS
        //     ],
        //     numeric: [
        //         FilterMatchMode.EQUALS,
        //         FilterMatchMode.NOT_EQUALS,
        //         FilterMatchMode.LESS_THAN,
        //         FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        //         FilterMatchMode.GREATER_THAN,
        //         FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
        //     ],
        //     date: [
        //         FilterMatchMode.DATE_IS,
        //         FilterMatchMode.DATE_IS_NOT,
        //         FilterMatchMode.DATE_BEFORE,
        //         FilterMatchMode.DATE_AFTER
        //     ]
        // }


    const filters = {
            'agent_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'policy_number': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'product_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'distribution': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'agent_number': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'first_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'last_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'team_title': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'parent_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'commencement_date': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },

        }


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            <Link to="/reports"><a href><i className="fa fa-folder-tree"/>&nbsp;Reports</a> </Link>
                            &nbsp;|&nbsp;
                            Pfuma / Inotho Policies Due To Mature
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Loading Pfuma / Inotho Policies Due To Mature, Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row mt">

                                <div className="col-lg-12">

                                    {/*    tabs*/}
                                    <div className="card">
                                        <h5 className="title h3 px-4">Pfuma / Inotho Policies Due To Mature</h5>
                                        <Tooltip target=".export-buttons>button" position="bottom"/>
                                        <DataTable value={data} responsiveLayout="scroll" header={header}
                                                   paginator
                                                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                   rowsPerPageOptions={[10, 25, 50]}
                                                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                   rows={10}
                                                   sortMode="multiple" filters={filters} filterDisplay="menu"
                                                   resizableColumns
                                                   ref={dt}
                                                   dataKey="id"
                                                   scrollable scrollHeight="700px"
                                                   selection={selectedData} onSelectionChange={onSelectionChange}
                                                   selectionMode="checkbox"
                                        >
                                            <Column selectionMode="multiple"/>
                                            <Column field="policy_number" header="Policy Number" filter
                                                    style={{minWidth: '12rem'}}></Column>
                                            <Column field="policy_type" header="Policy Type" filter
                                                    style={{minWidth: '12rem'}}></Column>
                                            <Column field="commencement_date" style={{minWidth: '14rem'}}
                                                    header="Commencement Date" filter
                                                    filterField="commencement_date"
                                            ></Column>
                                            <Column field="premium" style={{minWidth: '12rem'}}
                                                    header="Premium"></Column>
                                            <Column field="total_premium" style={{minWidth: '12rem'}}
                                                    header="Total Premium"></Column>
                                            <Column field="sum_assured" style={{minWidth: '12rem'}}
                                                    header="Sum Assured"></Column>
                                            <Column field="payment_frequency" style={{minWidth: '12rem'}}
                                                    header="Payment Frequency"></Column>
                                            <Column field="payment_method" style={{minWidth: '12rem'}}
                                                    header="Payment Method" filter></Column>
                                            <Column field="months_with_full_payment" style={{minWidth: '14rem'}}
                                                    header="Full Payment(Months)"></Column>
                                            <Column field="next_invoicing_date" style={{minWidth: '14rem'}}
                                                    header="Next Invoicing Date"></Column>
                                            <Column field="policy_status" style={{minWidth: '12rem'}} header="Status"
                                                    filter></Column>
                                            <Column filter field="created_at" style={{minWidth: '12rem'}}
                                                    header="Created At"></Column>
                                            <Column filter field="created_by" style={{minWidth: '12rem'}}
                                                    header="Created By"></Column>
                                            <Column filter field="updated_at" style={{minWidth: '12rem'}}
                                                    header="Updated At"></Column>
                                            <Column filter field="updated_by" style={{minWidth: '9rem'}}
                                                    header="Updated By"></Column>
                                        </DataTable>
                                    </div>
                                    {/*    end tabs*/}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )

}

export default InothoPoliciesDueToMatureReport
